import React, { Component } from 'react'
import '../App.css'
import { Button, Grid, Row, Col } from 'react-bootstrap'

export default class PageHeader extends Component {
  render () {
    return (
      <div className='Menu'>
        <Grid fluid>
          <Row>
            <Col md={12} sm={2} xs={3}>
              <div className='menu-content left-align'>
                <span className='menu-content-span'>
                  <Button bsStyle='default' selected={this.props.selected === 'profile'} onClick={() => this.props.onPageSelected('profile')}>My Profile</Button>
                </span>
              </div>
            </Col>
            <Col md={12} sm={2} xs={3}>
              <div className='menu-content left-align'>
                <span className='menu-content-span'>
                  <Button bsStyle='default' selected={this.props.selected === 'friends'} onClick={() => this.props.onPageSelected('friends')}>Friends</Button>
                </span>
              </div>
            </Col>
            <Col md={12} sm={2} xs={3}>
              <div className='menu-content left-align'>
                <span className='menu-content-span'>
                  <Button bsStyle='default' selected={this.props.selected === 'addFriends'} onClick={() => this.props.onPageSelected('addFriends')}>Search</Button>
                </span>
              </div>
            </Col>
            <Col md={12} sm={2} xs={3}>
              <div className='menu-content left-align'>
                <span className='menu-content-span'>
                  <Button bsStyle='default' selected={this.props.selected === 'addSingle'} onClick={() => this.props.onPageSelected('addSingle')}>Add Single</Button>
                </span>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Menu.js